import './TypographyExample.scss';

/**
 * Font faces and sizes used in Scalyr
 */

function TypographyExamplePage(): JSX.Element {
  const mainFont = 'Lato';

  return (
    <section id="typography" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Typography</h1>
      <div className="ExamplesPage__FontRow mb-4">
        <div className="FontSample mr-4">Aa</div>
        <div>
          <div className="ExamplesPage__Subhead">Main Font</div>
          <div className="ExamplesPage__FontName">{mainFont}</div>
        </div>
      </div>
      <div className="ExamplesPage__FontRow mb-5">
        <div className="FontSample Monospaced mr-4">Aa</div>
        <div>
          <div className="ExamplesPage__Subhead">Monospace</div>
          <div className="ExamplesPage__FontName Monospaced">Menlo Regular</div>
        </div>
      </div>

      <div className="ExamplesPage__Subhead mb-2">Styles</div>
      <div className="mb-5">
        <div className="ExamplesPage__ExampleRow--TextStyles">
          <div>Regular text</div>
          <div className="muted">Muted text</div>
          <div>
            <a href="#">Linked text</a>
          </div>
        </div>
      </div>

      <div className="ExamplesPage__Subhead mb-3">Sizes</div>
      <div className="ExamplesPage__ExampleRow d-flex">
        <div>$font-xs</div>
        <div>.69rem;&nbsp;&nbsp;// 11.04px</div>
        <div>
          <div className="font-sample font-xs">The quick brown fox jumped over the lazy dogs</div>
        </div>
      </div>
      <div className="ExamplesPage__ExampleRow d-flex">
        <div>$font-sm</div>
        <div>.75rem;&nbsp;&nbsp;// 12px</div>
        <div>
          <div className="font-sample font-sm">The quick brown fox jumped over the lazy dogs</div>
        </div>
      </div>
      <div className="ExamplesPage__ExampleRow d-flex">
        <div>$font-medium</div>
        <div>.875rem;&nbsp;// 14px</div>
        <div>
          <div className="font-sample font-medium">The quick brown fox jumped over the lazy dogs</div>
        </div>
      </div>
      <div className="ExamplesPage__ExampleRow d-flex">
        <div>$font-lg</div>
        <div>1.09rem; // 17.5px</div>
        <div>
          <div className="font-sample font-lg">The quick brown fox jumped over the lazy dogs</div>
        </div>
      </div>
      <div className="ExamplesPage__ExampleRow d-flex">
        <div>$font-xl</div>
        <div>1.37rem; // 21.88px</div>
        <div>
          <div className="font-sample font-xl">The quick brown fox jumped over the lazy dogs</div>
        </div>
      </div>
      <div className="ExamplesPage__ExampleRow d-flex">
        <div>$font-xxl</div>
        <div>1.71rem; // 27.35px</div>
        <div>
          <div className="font-sample font-xxl">The quick brown fox jumped over the lazy dogs</div>
        </div>
      </div>
      <div className="ExamplesPage__ExampleRow d-flex">
        <div>$font-xxxl</div>
        <div>2.14rem; // 34.19px</div>
        <div>
          <div className="font-sample font-xxxl">The quick brown fox jumped over the lazy dogs</div>
        </div>
      </div>
    </section>
  );
}
export default TypographyExamplePage;
